/*
 * Ryan O'Dowd
 * 2024-01-24
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors, fonts}) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 4,
      textDecoration: 'none',
      // @TODO: marginBottom: 64,
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      color: colors.primaryExtraLight,
      backgroundColor: colors.primaryExtraDark,
      paddingTop: 4,
      paddingRight: 12,
      paddingBottom: 12,
      paddingLeft: 12,
      cursor: 'pointer',
      width: 300,
      minHeight: 140,
    },
    nameAndStatus: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    goalName: {
      marginTop: 8,
      fontSize: globalScale * 16,
      color: colors.primaryExtraLight,
      fontFamily: fonts.secondaryBold,
    },
    goalDates: {
      color: colors.accent,
      fontSize: 14,
    },
    icon: {
      marginTop: 8,
      marginLeft: 8,
      fontSize: 24,
    },
    publishedIcon: {
      color: colors.accentDark,
    },
    draftIcon: {
      color: colors.warnIncorrect,
    },
    goalMetadataWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 12,
    },
    goalMetadata: {
      fontStyle: 'italic',
      fontSize: 14,
      color: colors.primaryExtraLight,
    },
  };
};

export default getStyles;
